import type { ApprovalAttributes } from '@/types/approval';

export const WORK_SPECIFICATION_TYPE = 183;

export const isWorkSpecificationType = (apvType: number): boolean =>
  apvType === WORK_SPECIFICATION_TYPE;

/** 「담당자별 체크 필요 항목」 — 레거시처럼 언어와 무관하게 한국어 문구가 곧 저장값 */
export const WORK_SPEC_CHECKLIST_OPTIONS = [
  '국문/영문 확인 완료',
  '다국어 확인 완료',
  '법적 필수사항 확인 완료',
  '바코드/자재코드 확인 완료',
] as const;

export const WORK_SPEC_CHECKLIST_REQUIRED_MESSAGE =
  '체크리스트는 최소 1개 이상 체크되어야 등록 가능합니다.';

/** 레거시는 임시저장도 같은 검사 */
export const checkWorkSpecificationBeforeSave = (
  checklist: string[] | null | undefined,
): string | null =>
  checklist && checklist.length > 0
    ? null
    : WORK_SPEC_CHECKLIST_REQUIRED_MESSAGE;

/** 단건조회 attributes.checklist. 배열이 아니면 null. 레거시 값 끝 공백은 그대로 둠(표시용) */
export const parseWorkSpecificationChecklist = (
  attributes: unknown,
): string[] | null => {
  if (!attributes || typeof attributes !== 'object') return null;
  const raw = (attributes as Record<string, unknown>).checklist;
  if (!Array.isArray(raw)) return null;
  return raw.filter((v): v is string => typeof v === 'string');
};

/** 저장 문구 → 폼 값. 레거시 값 끝 공백 무시, 옵션 순서로 정렬 */
export const checklistToOptionKeys = (saved: string[]): string[] => {
  const savedSet = new Set(saved.map((s) => s.trim()));
  return WORK_SPEC_CHECKLIST_OPTIONS.filter((key) => savedSet.has(key));
};

/** 옵션 순서 유지 */
export const buildWorkSpecificationAttributes = (
  checklist: string[] | null | undefined,
): ApprovalAttributes => ({ checklist: checklist ?? [] });

export const workSpecChecklistKey = (
  checklist: string[] | null | undefined,
): string => (checklist ?? []).join('|');
